import { jsx as _jsx } from "react/jsx-runtime";
import { DeviceTypes } from '@iotv/iotv-v3-types';
import { LFCSolenoidControls } from '../../../../v2/components/generic/Control/LFC-Devices/CommonControls/LFCSolendoidControls';
import ConfigActionTable from './ConfigActionTable';
const IoTVDeviceControlsArbitrator = ({ device, config }) => {
    if (device.deviceType === DeviceTypes.ValveAct)
        return _jsx(LFCSolenoidControls, { devices: [device], config });
    return _jsx(ConfigActionTable, { device, config });
};
export default IoTVDeviceControlsArbitrator;
